import {RoleInfoRow} from "@components/roles/info/RoleInfoRow.tsx";
import {RolesFilterPage} from "@components/roles/pages/RolesFiltersPage.tsx";
import {RolesPesquisa} from "@components/roles/RolesPesquisa.tsx";
import {SearchTextField} from "@components/shared/textField/SearchTextField.tsx";
import {useAlert} from "@contexts/hooks/useAlert.ts";
import {useContextMenu} from "@contexts/hooks/useContextMenu.ts";
import {DefaultPageProps} from "@models/DefaultProps.ts";
import {IGetRolesFilter} from "@models/roles/IGetRolesFilter.ts";
import {IRole} from "@models/roles/roles.ts";
import {IHasValueCheck} from "@models/shared/IHasValueCheck.ts";
import {MoreVert} from "@mui/icons-material";
import {Button, Grid, IconButton, Table, TableBody, TableCell, TableContainer, TableHead} from "@mui/material";
import {DefaultContainer} from "@shared/DefaultContainer.tsx";
import React, {useMemo, useState} from "react";
import {useRoles} from "@components/roles/hooks/useRoles.ts";
import usePagination from "@components/shared/hooks/usePagination.tsx";

interface RolesPageProps extends DefaultPageProps {
	filters?: IGetRolesFilter,
}

export function RolesPage(props: RolesPageProps) {
	const {setContextOptions} = useContextMenu()
	const {getRoles, addRoleMembro, removeRoleMembro} = useRoles();
	const {createAlertFromResponse, addPopUp, closePopUp} = useAlert()
	const [pagination, setPagination] = usePagination({
		...props.pageProps, triggers: [
			{
				eventName: 'process',
				promise: (p) => getRoles({data: filters, pagination: p.pagination}).then(x => {
					if (x.items) {
						setRoles(x.items)
					}
					return x
				})
			}
		]
	});
	const [filters, setFilters] = useState<IGetRolesFilter>(props.filters ?? {});
	const [roles, setRoles] = useState<IRole[]>([])

	const userSelected = useMemo<IHasValueCheck<number>>(() => {
		if (filters?.membroId?.length != 1) return {hasValue: false}

		return {hasValue: true, value: filters.membroId[0]}
	}, [filters?.membroId])

	const contextMenuHandler = (event: React.MouseEvent<HTMLButtonElement>, role: IRole) => {
		setContextOptions({
			event,
			anchor: event.currentTarget,
			options: [
				{
					label: 'Remover usuario',
					disabled: !userSelected,
					permission: ['CriarRole'],
					onClick: () => {
						const m = filters?.membroId
						if (m == null) return

						removeRoleMembro({data: {roleId: role.id, usuarioId: m[0]}}).then(x => {
							createAlertFromResponse(x)
						})
					}
				}
			]
		})
	}

	const handleApply = () => {
		setPagination(prevState => ({...prevState, page: 0}))
	}


	return (<DefaultContainer hideHeader={props.hideHeader} pageProps={{pagination, setPagination}}
	                          UpperComponent={<Grid spacing={1} container>
		                          <Grid size={{sm: 12, md: 6}}>
			                          <SearchTextField value={filters.nome ?? ''}
			                                           label={'Pesquisar role'}
			                                           onChange={(e) => setFilters(prevState => ({
				                                           ...prevState,
				                                           nome: e.target.value
			                                           }))}
			                                           openFilters={() => {
				                                           addPopUp({
					                                           title: "Filtros",
					                                           content: <RolesFilterPage filters={filters}
					                                                                     setFilters={setFilters}
					                                                                     onApply={() => {
						                                                                     closePopUp()
						                                                                     handleApply()
					                                                                     }}
					                                           />
				                                           })
			                                           }}
			                                           pageProps={{pagination, setPagination}}
			                                           onSearch={handleApply}
			                          />
		                          </Grid>
		                          {userSelected.hasValue && <Grid size={{sm: 12, md: 6}}>
			                          <RolesPesquisa onItemSelected={(r) => {
				                          if (r != null) {
					                          addPopUp({
						                          title: 'Adicionar usuario a Role',
						                          content: <Grid>
							                          <Button onClick={() => {
								                          if (userSelected.value != null)
									                          addRoleMembro({
											                          data: {
												                          roleId: r.id,
												                          usuarioId: userSelected.value
											                          }
										                          }
									                          ).then(x => {
										                          createAlertFromResponse(x)
									                          })

							                          }}>Adicionar</Button>
						                          </Grid>
					                          })
				                          }
			                          }}/>
		                          </Grid>}
	                          </Grid>}>
		<TableContainer>
			<Table size={'small'} stickyHeader>
				<TableHead>
					<TableCell>Id</TableCell>
					<TableCell>Nome</TableCell>
					<TableCell>Descricao</TableCell>
					<TableCell>Criação</TableCell>
					<TableCell>Criador</TableCell>
					<TableCell>Mais...</TableCell>
				</TableHead>
				<TableBody>
					{roles.map(x => (<RoleInfoRow value={x} EndComponent={(x) => (<IconButton
						onClick={(e) => contextMenuHandler(e, x)}>
						<MoreVert/>
					</IconButton>)}/>))}
				</TableBody>
			</Table>
		</TableContainer>
	</DefaultContainer>)
}